module.exports = __webpack_public_path__ + "static/img/kiwiLoadingLogo.ee10be5.png";


//////////////////
// WEBPACK FOOTER
// ./src/res/kiwiLoadingLogo.png
// module id = DFuw
// module chunks = 1